import { render, staticRenderFns } from "./ServiceInvoiceFormDefaultSettings.vue?vue&type=template&id=37b9629c&scoped=true&"
import script from "./ServiceInvoiceFormDefaultSettings.vue?vue&type=script&lang=js&"
export * from "./ServiceInvoiceFormDefaultSettings.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInvoiceFormDefaultSettings.vue?vue&type=style&index=0&id=37b9629c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9629c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VAutocomplete,VCard,VCardText,VChip,VIcon,VTooltip})
